import React, { createContext } from "react"
import useModal from "mobile/hooks/useModal"

import ModalOverlay from "."

const ModalContext = createContext()
const { Provider } = ModalContext

const ModalProvider = ({ children }) => {
  const { modal, handleModal, modalContent } = useModal()
  return (
    <Provider value={{ modal, handleModal, modalContent }}>
      <ModalOverlay />
      {children}
    </Provider>
  )
}

export { ModalContext, ModalProvider }
